import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { ReviewWorkbenchPage } from "@client/components/doc-center/review-workbench";

const reviewDetailSearchSchema = z.object({
  fileId: z.string().optional(),
  returnTo: z.string().optional(),
  mode: z.enum(["preview", "review"]).optional(),
  /** 来源：list=数据抽取任务列表（默认）、detail=任务详情页、review=审核任务列表、file=文件详情；返回按钮按此分流 */
  from: z.enum(["list", "detail", "review", "file"]).optional(),
});

/**
 * 审核工作台详情页（全屏独立页）：
 * 根层级路由（不经过 _app shell），无侧边栏；
 * search.from 标记来源；血缘在新标签页以 mode=preview 打开，切换模式保留任务、文件和返回上下文。
 */
export const Route = createFileRoute("/data-center/review/$taskId")({
  validateSearch: reviewDetailSearchSchema,
  component: ReviewDetailWrapper,
});

function ReviewDetailWrapper() {
  const { taskId } = Route.useParams();
  const { fileId } = Route.useSearch();
  return <ReviewWorkbenchPage taskId={taskId} initialFileId={fileId} />;
}
